import { render, staticRenderFns } from "./send_record.vue?vue&type=template&id=4e09fd5e&scoped=true&"
import script from "./send_record.vue?vue&type=script&lang=js&"
export * from "./send_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e09fd5e",
  null
  
)

export default component.exports